import { breakpoints } from '@/shared/constants/constants';
import { removeHiddenClassFromBuyNowPayLaterModal } from '@/shared/instances/hobbii-modal';
import { initZuzanaVisibility } from '@/shared/instances/zuzana-visibility';
import {
  initMerchandisingBoxTracking,
  initNavigationTracking,
  initTopBannerTracking
} from '@/shared/tracking/navigation-tracking';
import { initSectionTracking } from '@/shared/tracking/section-tracking';
import {
  applyABTestSections,
  initializePatternsLandingTestQAOverride
} from '@/shared/utils/ab-test-sections';
import { initAccountLoginRedirect } from '@/shared/utils/account-login-redirect';
import { initConditionalRedirect } from '@/shared/utils/conditional-redirect';
import { isMobileView } from '@/shared/utils/dom';

import { setCart } from './helpers/cart-helpers/cart';
import { showDiscountNotification } from './helpers/show-discount-notification';

let isMobile = false;

// Runs as soon as this module executes -- ahead of DOMContentLoaded and the
// rest of this file's setup -- so a guest on the account page or a
// signed-in customer on login/signup is sent on their way with minimal delay.
initConditionalRedirect();
initAccountLoginRedirect();

const scrollUpToRemoveEmptySpace = () => {
  const submenus = document.querySelectorAll('.submenu');
  submenus.forEach((el) => {
    el.scroll({
      top: 0,
      behavior: 'smooth'
    });
  });
};

const setMenus = () => {
  // Offcanvas Menu Toggle
  const toggleMenu = document.querySelectorAll('.hb-toggle-menu');
  const navigationElm = document.querySelector('.hb-navigation');
  const hamburgerElm =
    document.querySelector<HTMLButtonElement>('.hb-hamburger');
  let isExpanded = false;
  const body = document.querySelector('body');

  // The offcanvas menu is off-screen below the `lg` breakpoint until it is
  // toggled open, but its submenu links stay in the Tab order unless we take
  // them out. The desktop layout keeps the same markup permanently visible,
  // so inert must only apply to the closed mobile state.
  const desktopMedia = window.matchMedia(`(min-width: ${breakpoints.lg}px)`);
  const syncMenuInert = () => {
    if (!navigationElm) return;
    if (!desktopMedia.matches && !isExpanded) {
      navigationElm.setAttribute('inert', '');
    } else {
      navigationElm.removeAttribute('inert');
    }
  };
  syncMenuInert();
  desktopMedia.addEventListener('change', syncMenuInert);

  toggleMenu.forEach((btn) => {
    btn.addEventListener('click', () => {
      isExpanded = !isExpanded;
      hamburgerElm?.setAttribute('aria-expanded', String(isExpanded));
      navigationElm?.classList.toggle('offcanvas--open');
      body?.classList.toggle('menu-open');
      // Move focus back to the hamburger before applying inert, otherwise the
      // browser blurs the in-menu close button to body when the nav turns inert.
      if (!isExpanded) hamburgerElm?.focus();
      syncMenuInert();
    });
  });

  const hasSubmenu = document.querySelectorAll('[data-has-submenu]');
  hasSubmenu.forEach((item) => {
    item.addEventListener('click', (e) => {
      if (!isMobile) {
        return;
      }
      e.preventDefault();
      scrollUpToRemoveEmptySpace();

      item
        .closest('li')
        ?.querySelectorAll('.submenu')[0]
        .classList.toggle('submenu--active');
    });
  });

  const closeSubmenu = document.querySelectorAll('[data-close-submenu]');
  closeSubmenu.forEach((item) => {
    item.addEventListener('click', () => {
      item.closest('.submenu')?.classList.remove('submenu--active');
    });
  });

  // Tabs in Yarn-mobile menu
  const menuTabs = document.querySelectorAll('[data-menu-tab]');
  menuTabs.forEach((tab) => {
    tab.addEventListener('click', (e) => {
      const menuTabContent = document.querySelectorAll(
        '[data-menu-tab-content]'
      );
      const tabEl = tab as HTMLElement;
      const activeContents = document.querySelectorAll(
        `[name=${tabEl.dataset.menuTab}]`
      );

      menuTabs.forEach((item) => {
        item.classList.remove('tab--active');
      });
      (e.target as HTMLElement).classList.add('tab--active');

      menuTabContent.forEach((item) => {
        item.classList.remove('block');
        item.classList.add('hidden');
      });

      activeContents.forEach((activeContent) => {
        activeContent.classList.remove('hidden');
        activeContent.classList.add('block');
      });
    });
  });
};

const setIsMobile = () => {
  isMobile = isMobileView();
};

window.addEventListener('resize', setIsMobile);

document.addEventListener('DOMContentLoaded', () => {
  setCart();
  setMenus();
  setIsMobile();
  removeHiddenClassFromBuyNowPayLaterModal();
  showDiscountNotification();
  initializePatternsLandingTestQAOverride();
  applyABTestSections();
  initNavigationTracking();
  initTopBannerTracking();
  initMerchandisingBoxTracking();
  initSectionTracking();
  initZuzanaVisibility();
});
